import { Trans } from '@lingui/macro';
import TestFormSection from './TestFormSection/TestFormSection';

const TestEmptyRunScheduleSection = () => {
    return <TestFormSection title={<Trans>Run Schedule</Trans>} />;
};

export default TestEmptyRunScheduleSection;
